import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import { Hero } from "./components/landing/Hero";
import { MarqueeStrip } from "./components/landing/Marquee";
import { BeforeAfter } from "./components/landing/BeforeAfter";
import { CoreFunctions } from "./components/landing/CoreFunctions";
import { BentoFeatures } from "./components/landing/BentoFeatures";
import { Replaces } from "./components/landing/Replaces";
import { FeatureMatrix } from "./components/landing/FeatureMatrix";
import { AIAutomation } from "./components/landing/AIAutomation";
import { LeadershipView } from "./components/landing/LeadershipView";
import { Outcomes } from "./components/landing/Outcomes";
import { Architecture } from "./components/landing/Architecture";
import { BuiltForWho } from "./components/landing/BuiltForWho";
import { Pricing } from "./components/landing/Pricing";
import { Testimonials } from "./components/landing/Testimonials";
import { FAQ } from "./components/landing/FAQ";
import AboutPage from "./pages/AboutPage";
import PricingPage from "./pages/PricingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentFailurePage from "./pages/PaymentFailurePage";
import PaymentResultPage from "./pages/PaymentResultPage";
import FAQsPage from "./pages/FAQsPage";
import PoliciesPage from "./pages/PoliciesPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import DocsPage from "./pages/DocsPage";
import StartupsPage from "./pages/StartupsPage";
import UseCasesPage from "./pages/UseCasesPage";
import CompliancePage from "./pages/CompliancePage";
import HelpPage from "./pages/HelpPage";
import ComparePage from "./pages/ComparePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ChangelogPage from "./pages/ChangelogPage";
import RoadmapPage from "./pages/RoadmapPage";
import SecurityPage from "./pages/SecurityPage";
import CareersPage from "./pages/CareersPage";
import ContactSalesPage from "./pages/ContactSalesPage";
import StatusRedirect from "./pages/StatusRedirect";
import { SeoProvider } from "./context/SeoContext";

function Landing() {
    return (
        <div data-testid="landing-page">
            <Hero />
            <CoreFunctions />
            {/* <MarqueeStrip /> */}
            <BeforeAfter />
            <BentoFeatures />
            <Replaces />
            <FeatureMatrix />
            <AIAutomation />
            {/* <LeadershipView /> */}
            <Outcomes />
            {/* <Architecture /> */}
            <BuiltForWho />
            {/* <Pricing /> */}
            <Testimonials />
            {/* <FAQ /> */}
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SeoProvider>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Landing />} />
                        <Route path="about" element={<AboutPage />} />
                        <Route path="pricing" element={<PricingPage />} />
                        <Route
                            path="pricing/payment/success"
                            element={<PaymentSuccessPage />}
                        />
                        <Route
                            path="pricing/payment/failure"
                            element={<PaymentFailurePage />}
                        />
                        <Route
                            path="pricing/payment/result"
                            element={<PaymentResultPage />}
                        />
                        <Route path="faqs" element={<FAQsPage />} />
                        <Route path="policies" element={<PoliciesPage />} />
                        <Route path="case-studies" element={<CaseStudiesPage />} />
                        <Route path="docs" element={<DocsPage />} />
                        <Route path="startups" element={<StartupsPage />} />
                        <Route path="use-cases" element={<UseCasesPage />} />
                        <Route path="compliance" element={<CompliancePage />} />
                        <Route path="help" element={<HelpPage />} />
                        <Route path="compare" element={<ComparePage />} />
                        <Route path="blog" element={<BlogPage />} />
                        <Route path="blog/:slug" element={<BlogPostPage />} />
                        <Route path="changelog" element={<ChangelogPage />} />
                        <Route path="roadmap" element={<RoadmapPage />} />
                        <Route path="security" element={<SecurityPage />} />
                        <Route path="careers" element={<CareersPage />} />
                        <Route path="contact-sales" element={<ContactSalesPage />} />
                        <Route path="status" element={<StatusRedirect />} />
                    </Route>
                </Routes>
                </SeoProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
